import { TradeStateT } from "types";
import { initialOrdersState } from "./orders";

export const initialTradeState: TradeStateT = {
  orders: initialOrdersState,
}
